module.exports = __webpack_public_path__ + "style/img/PD_icon_Menhu 1.df56507e.png";